export default __webpack_public_path__ + "media/atlassian-rovo-collection.f8527bf38358c8e1749511521aab4f4f.svg";